import { take, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EquipmentPartUsage } from '../_models/cobo/equipmentPartUsage';

@Injectable()
export class EquipmentPartUsagesService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryServiceUrl = environment.telemetryServiceUrl;
  public list = new BehaviorSubject<EquipmentPartUsage[]>([]);

  constructor(private http: HttpClient) {}

  getList(equipment): Observable<any[]> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/equipmentPartUsages/listAllResources?equipmentId=' +
          equipment
      )
      .pipe(
        map((response) => {
          if (response) {
            this.list.next(response);
            return response;
          }
        })
      );
  }

  deleteEquipmentPartUsage(equipmentPartUsage): Observable<EquipmentPartUsage> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/equipmentPartUsages/' + equipmentPartUsage.id)
      .pipe(
        map((response) => {
          this.list.pipe(take(1)).subscribe((elements) => {
            const index = elements.findIndex((xList) => xList.id === equipmentPartUsage.id);
            if (index !== -1) {
              elements.splice(index, 1);
              this.list.next([...elements]);
            }
          });
          return response;
        })
      );
  }

  saveEquipmentPartUsage(equipmentPartUsage): Observable<EquipmentPartUsage> {
    if (equipmentPartUsage.id) {
      return this.http
        .put<EquipmentPartUsage>(
          this.apiBaseUrl + 'api/private/v1/equipmentPartUsages' + '/' + equipmentPartUsage.id,
          equipmentPartUsage
        )
        .pipe(
          map((response) => {
            if (response) {
              if (response) {
                this.list.pipe(take(1)).subscribe((elements) => {
                  elements.splice(
                    elements.findIndex((xList) => xList.id === response.id),
                    1,
                    response
                  );
                  this.list.next(elements);
                });
              }
            }
            return response;
          })
        );
    } else {
      return this.http
        .post<EquipmentPartUsage>(
          this.apiBaseUrl + 'api/private/v1/equipmentPartUsages',
          equipmentPartUsage
        )
        .pipe(
          map((response) => {
            if (response) {
              if (response) {
                this.list.pipe(take(1)).subscribe((elements) => {
                  elements.push(response);
                  this.list.next(elements);
                });
              }
            }
            return response;
          })
        );
    }
  }
}
